import { CmsImageData } from '@fcom/core-api';
import { AmDestinationOffer } from '@fcom/destination-search/interfaces/destination-search.interface';

import { MarketingOffer, MarketingOfferPrices } from './marketing-offer.interface';

export enum BadgeIcon {
  TRENDING = 'trending-arrow-up',
  OFFERS = 'discounted-price',
}

export interface BlockOfferData {
  /**
   * Plain text, ultra black heading
   */
  title: string;
  /**
   * Rich text that renders below the heading. Will be hidden if not set.
   */
  subtitle?: string;
  /**
   * Plain text for offer badge label. Will be hidden if not set.
   */
  badgeLabel?: string;
  badgeIcon?: BadgeIcon;
  /**
   * Price that renders below the subtitle. Using pipes for currency, Will be hidden if not set.
   */
  price?: number;
  /**
   * Call to action button text. Button will be hidden if not set.
   */
  callToAction?: string;

  /**
   * The two character country code if a flag should be shown above the title.
   * The flag is hidden if not specified.
   */
  flag?: string;

  /**
   * The (internal) url to navigate to when clicked
   */
  link: string;
  /**
   * The background image data
   */
  imageData: CmsImageData;

  /**
   * The destination code, e.g. BER or HEL
   */
  destination: string;

  onewayPrice?: MarketingOfferPrices;
  returnPrice?: MarketingOfferPrices;
  enableBlackTeaser?: boolean;
  amDestination?: AmDestinationOffer;
  isShortHaul?: boolean;
}

export interface BlockOffer extends BlockOfferData {
  countryName?: string;
  marketingOffer?: MarketingOffer;
}

export interface DestinationSearchBlockOffer extends BlockOffer {
  rank?: number;
  currency?: string;
  origin?: string;
  titleMaster?: string;
  listPosition?: number;
  continent?: string;
  continentLocale?: string;
  locationCode?: string;
}
